export const routePairs = [
  ['/', '/en'],
  ['/tilbud', '/en/get-a-quote'],
  ['/kontakt', '/en/contact'],
  ['/om-os', '/en/about'],
  ['/blikkenslager', '/en/sheet-metal'],
  ['/nybyggeri', '/en/new-construction'],
  ['/erhverv', '/en/commercial'],
  ['/referencer', '/en/references'],
  ['/karriere', '/en/careers'],
  ['/faq', '/en/faq'],
  ['/privatlivspolitik', '/en/privacy-policy'],
  ['/service-og-vedligehold', '/en/service-maintenance'],
  ['/vvs', '/en/plumbing'],
  ['/vvs/badevaerelser', '/en/plumbing/bathrooms'],
  ['/vvs/roerinstallationer', '/en/plumbing/pipework-water-damage'],
  ['/vvs/ventilation', '/en/plumbing/ventilation'],
  ['/vvs/akut-vvs', '/en/plumbing/emergency'],
  ['/varme/varmepumper', '/en/heating/heat-pumps'],
  ['/varme/fjernvarme', '/en/heating/district-heating'],
  ['/varme/varmeanlaeg', '/en/heating/heating-systems'],
  ['/guides', '/en/guides'],
  ['/guides/hvad-koster-en-varmepumpe', '/en/guides/heat-pump-cost'],
  ['/guides/frostspraengte-roer', '/en/guides/frozen-pipes'],
  ['/guides/fjernvarme-eller-varmepumpe', '/en/guides/district-heating-or-heat-pump'],
  ['/vvs-billund', '/en/plumber-billund'],
  ['/vvs-grindsted', '/en/plumber-grindsted'],
  ['/vvs-give', '/en/plumber-give'],
  ['/vvs-vejle', '/en/plumber-vejle'],
  ['/vvs-soender-omme', '/en/plumber-soender-omme']
];

export function getEquivalentRoute(currentPath, targetLang) {
  // Normalize trailing slash
  const norm = currentPath === '/' ? '/' : currentPath.replace(/\/+$/, '');
  
  for (const [daPath, enPath] of routePairs) {
    if (norm === daPath || norm === daPath + '/') {
      return targetLang === 'en' ? enPath : daPath;
    }
    if (norm === enPath || norm === enPath + '/') {
      return targetLang === 'da' ? daPath : enPath;
    }
  }

  // Fallback
  return targetLang === 'en' ? '/en' : '/';
}
